<!--
	TEMPLATE
-->
<template>
	<div class="md-grey-page">
		<div class="edit-page container margin-top-60" v-if="!ownerLoaded">
			<p class="loading-text">Loading owner<span>.</span><span>.</span><span>.</span></p>
		</div>

		<div class="edit-page container" v-if="ownerLoaded">

		  <div class="mdc-layout-grid">
			<div class="mdc-layout-grid__inner edit-page__inner">
			  	<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">

					  <div class="edit-page__header edit-page__info mdc-layout-grid__cell--span-3">
							<h3 class="edit-page__title">{{ owner.fullName }} <i v-if="owner.emailConfirmed || owner.mobileConfirmed" class="ico-checkmark applicants-list__checkmark"></i></h3>
							<div class="owner-icons" style="text-align: center; font-size: 20px;">
                <div v-if="owner.applicantId">
                  <a href="javascript:;" @click.prevent="$router.push('/applicants/'+owner.applicantId)" style="color:white">
                    <i class="ico-applicants"></i> <small>Applicant</small>
                  </a>
                </div>
							</div>
					  </div>
            <div class="mdc-layout-grid__cell--span-3 edit-page__make-applicant">
              <a @click.prevent="makeApplicant()" v-if="!owner.applicantId || owner.applicantId == ''">
                <i class="ico"><svg class="icon icon-user-tie"><use xlink:href="#icon-user-tie"></use></svg></i> <small>Make applicant</small>
              </a>
            </div>
				</div>

				<div class="edit-page__content mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
					<!-- Fullname -->
					<editable-item component="editable-input" v-model="owner.fullName" title="Full name" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateOwner" @back="getOwner" @hasErrors="errors('fullname', arguments[0])"></editable-item>

					<!-- Email -->
					<editable-item component="editable-input" v-model="owner.email" title="Email" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateOwner" @back="getOwner" @hasErrors="errors('email', arguments[0])"></editable-item>

					<!-- Mobile -->
					<editable-item component="editable-input" v-model="owner.mobile" title="Mobile" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateOwner" @back="getOwner" @hasErrors="errors('email', arguments[0])"></editable-item>

					<!-- Address -->
					<editable-item component="editable-address" v-model="address" title="Address" :options="{attentionSymbol: true}"
					@isEditView="editView(arguments[0])" @update="updateOwner" @back="getOwner" @hasErrors="errors('address', arguments[0])"></editable-item>

					<!-- Comments -->
					<editable-item component="editable-text" v-model="owner.comments" title="Comments" :options="{rows: 10}"
					@isEditView="editView(arguments[0])" @update="updateOwner" @back="getOwner" @hasErrors="errors('long', arguments[0])"></editable-item>

          <!-- Is from the UK -->
          <editable-item
            component="editable-options"
            v-model="owner.isuk"
            title="Is from the UK"
            :options="{items: [['false', 'No'],['true', 'Yes']]}"
            @isEditView="editView(arguments[0])"
            @update="updateOwner"
            @back="getOwner"
            @hasErrors="errors('isuk', arguments[0])">
          </editable-item>

					<!-- Delete and Archive this property -->
					<div class="editable-item mdc-layout-grid__inner">
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 editable-item__title">
							<a href="#" class="edit-page__delete message--error" @click.prevent="deleteOwner"><i class="ico ico-trash"></i>Delete this owner</a>
						</div>
					</div>
          <!-- Property listing -->
          <div class="container">
            <h3>Properties</h3>
            <property-box  v-for="(property, index) in owner.props" v-if="owner.propsCount > 0" :key="property.propertyId" :property="property" :arrayIndex="index" @remove="remove(arguments[0])" v-model="owner.props"></property-box>
          </div>
					</div>
				</div>
			</div>
		</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import EditableItem 	from '../components/editable-items/EditableItem.vue';
import PropertyBox from '../components/PropertyBox.vue';

export default {
	data: function() {
		return {
			ownerLoaded: false,
			owner: {},
			allErrors: {},
			budgetObj: {
				price: 0,
				rentFrequency: 'PCM',
				newPrice: 0
			},
			address: {
				number: '',
				flatNumber: '',
				street: '',
				postcode: '',
				town: '',
				county: '',
				lat: 0,
				lng: 0,
				addressNotEmpty: true
			}
		}
	},
	components: {
		'editable-item': EditableItem,
    'property-box': PropertyBox
	},
	mixins: [utils],
	created: async function() {
		// Get Owner
		await this.getOwner();
    if (!this.owner.comments) {
      this.owner.comments = '';
    }
    if (this.owner.isuk && (this.owner.isuk !== false && this.owner.isuk != 'false')) {
      this.owner.isuk = "true";
    } else {
      this.owner.isuk = "false";
    }
	},
	computed: {
	},
	methods: {
    makeApplicant: async function(){
      const makeowner = await api({endpoint: this.config.services.owners, path: `/toapplicant/${this.owner.companyId}/${this.owner.ownerId}`, method: 'GET'});
      if (makeowner && typeof makeowner == 'string' && makeowner != '') {
        let reurl = makeowner.replace(/http(s)?\:\/\/[^\/]+/i,"");
        //console.log(reurl);
        //window.open(got, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        this.$router.push(reurl);
      }
    },
		getOwner: async function() {
			this.owner = await api({endpoint: this.config.services.owners, path: '/' + this.$route.params.id, method: 'GET'});

			// Address
			this.address = this.owner.address;
			if(!this.address.buildingNumber) {
				this.address.buildingNumber = '';
			}
			this.address.addressNotEmpty = true;

			this.ownerLoaded = true;

      if (this.owner.isuk && (this.owner.isuk !== false && this.owner.isuk != 'false')) {
        this.owner.isuk = "true";
      } else {
        this.owner.isuk = "false";
      }
		},
		updateOwner: async function() {
			if(this.anyErrors()) {
				alert('Please fill in the missing values in order to proceed!');
				return false;
			}
			// Address
			this.owner.address.buildingNumber = this.address.buildingNumber ? this.address.buildingNumber : '';
			this.owner.address.flatNumber = this.address.flatNumber ? this.address.flatNumber : '';
			this.owner.address.street = this.address.street ? this.address.street.trim() : '';
			this.owner.address.postcode = this.address.postcode ? this.address.postcode : '';
			this.owner.address.town = this.address.town ? this.address.town.trim() : '';
			this.owner.address.county = this.address.county ? this.address.county.trim() : '';
			this.owner.address.latitude = this.address.latitude ? this.address.latitude : '';
			this.owner.address.longitude = this.address.longitude ? this.address.longitude : '';
      if (!this.owner.ownerId)
        this.owner.ownerId = this.$route.params.id;

			var result = await api({endpoint: this.config.services.owners, path: '/save', method: 'POST', body: this.owner});
			console.log('Saved',result);
		},
		 deleteOwner: async function() {
			 if(confirm('Are you sure you want to delete this owner?')) {
				 try {
					 var result = await api({endpoint: this.config.services.owners, path: '/' + this.$route.params.id, method: 'DELETE'});
					 this.$router.push('/owners');
				 } catch(err) {
					 throw {
 						type: 'delete-owner',
 						error: err
 					}
				 }
			 }
		},
		getType(type) {
			if(type == 'flat') {
				return 'Flat';
			} else if(type == 'house') {
				return 'House';
			} else if(type == 'either') {
				return 'Flat & House';
			} else {
				return '--';
			}
		},
		errors: function(item, hasErrors) {
			this.allErrors[item] = hasErrors;
		},
		anyErrors: function() {
			var self = this;
			return Object.keys(self.allErrors).reduce(function(acc, current) {
				if(self.allErrors[current]) {
					console.log('Found error: ', current);
				}
				return acc || self.allErrors[current];
			}, false);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Owners-Edit.vue